exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".geocoder-results {\n  font-size: 8pt; }\n\n.geocoder-results__address-segments {\n  border: 1px solid dimgray; }\n\n.geocoder-results__address-segments th {\n  padding: 4px; }\n\n.geocoder-results__address-segments td {\n  border: 1px solid dimgray;\n  padding: 4px;\n  vertical-align: top; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/geo/geocoder-result-detail.component.scss
// module id = ../../../../../src/app/shared/geo/geocoder-result-detail.component.scss
// module chunks = main